import React from "react";
import { useParams } from "react-router-dom";
import CardWithDetail from "../components/CardWithDetail";
import { useSiteContent } from "../content/SiteContentContext.jsx";

/**
 * Página genérica de una categoría de oferta (licenciaturas, maestrías, diplomados, doctorados…).
 * La categoría sale de la ruta (/:section) y las tarjetas se filtran por ese `section` en los datos,
 * así que agregar una categoría nueva desde el panel (un navLink + ofertas con ese section) crea su
 * página automáticamente, sin tocar código. El título se toma del menú (navLinks) si existe.
 */
const SectionPage = () => {
  const { section } = useParams();
  const { navLinks, academicDegrees } = useSiteContent();

  const navMatch = (navLinks || []).find((n) => n.link === `/${section}`);
  const title =
    navMatch?.title ||
    (section ? section.charAt(0).toUpperCase() + section.slice(1) : "");
  const count = (academicDegrees || []).filter((o) => o.section === section).length;

  return (
    <div className="w-full overflow-hidden footerAdjust">
      <header className="brand-gradient text-white relative overflow-hidden">
        <div className="blob-glow w-[420px] h-[420px] -top-40 -right-24" />
        <div className="mx-auto w-full max-w-[1180px] px-6 py-16 md:py-20 text-center relative z-[1]">
          <span className="eyebrow on-dark !text-[#9db8ff] justify-center">
            Oferta educativa
          </span>
          <h1 className="mt-4 font-bold text-3xl ss:text-4xl md:text-5xl">
            {title}
          </h1>
          <p className="mt-4 text-white/80 max-w-[620px] mx-auto">
            Impulsa tu carrera con formación presencial o en línea, acompañamiento cercano y
            certificación al concluir.
          </p>
          {count > 0 ? (
            <span className="pill pill-glass mt-7">
              <i className="fa-solid fa-graduation-cap" /> {count}{" "}
              {count === 1 ? "programa disponible" : "programas disponibles"}
            </span>
          ) : null}
        </div>
      </header>

      <div className="brand-soft pt-4 pb-16">
        <CardWithDetail section={section} />
      </div>
    </div>
  );
};

export default SectionPage;
